import { useMemo } from 'react';
import styled from 'styled-components';

import { Modal } from '@soluto-private/aui-react-modal';
import { Button } from '@soluto-private/mx-asurion-ui-react';

import { type OpenTimes } from '@service-initiation/tech-care-data-access-store';
import { convertOpenTimesToWeeklySchedule } from '@service-initiation/tech-care-utils-date-time';

const ScheduleContainer = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0.5em;
  margin-top: 1em;
`;

const ScheduleRow = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ScheduleItem = styled.div``;

export type StoreHoursModalProps = {
  header: string;
  isOpen: boolean;
  onCloseClick: () => void;
  primaryButtonLabel: string;
  storeDatesAndHours?: OpenTimes[];
};

export const StoreHoursModal = ({
  header,
  isOpen,
  onCloseClick,
  primaryButtonLabel,
  storeDatesAndHours,
}: StoreHoursModalProps) => {
  const formattedWeeklySchedule = useMemo(() => {
    return convertOpenTimesToWeeklySchedule(storeDatesAndHours);
  }, [storeDatesAndHours]);

  return (
    <Modal
      ariaLabel={header}
      isOpen={isOpen}
      onCloseModal={onCloseClick}
      style={{ width: '580px' }}
    >
      <Modal.Content>
        <Modal.Title size={4}>{header}</Modal.Title>
        <ScheduleContainer>
          {formattedWeeklySchedule.map((dayTime, idx) => {
            return (
              <ScheduleRow key={idx}>
                <ScheduleItem>{dayTime.day}</ScheduleItem>
                <ScheduleItem>{dayTime.time}</ScheduleItem>
              </ScheduleRow>
            );
          })}
        </ScheduleContainer>
      </Modal.Content>
      <Modal.Footer>
        <Button
          autoFocus
          data-testid="PrimaryModalButton"
          onClick={() => onCloseClick()}
        >
          {primaryButtonLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
